/*
 * 获取应用、图片接口分类
 */

/**
 * 通用获取图片接口
 */
const COMMON_APPS_ENDPOINTS = [
	// 获取应用列表（首页）
	/api\/community\/v1\/publications\/applications/,
	// 获取应用列表（玩一玩）
	/api\/community\/v1\/publications\/recommends\/v2/,
	// 排行榜
	/api\/community\/v1\/incentives\/rank-table/,
	// 相似应用
	/api\/community\/v1\/publications\/[\w\d]+\/similar/,
];

const HOME_FAVORITE_APPS_ENDPOINTS = [
	// 个人主页喜欢的应用
	/api\/community\/v1\/publications\/favorite/,
];

const HOME_APPS_ENDPOINTS = [
	// 个人主页应用
	/api\/resources\/v2\/applications\/home/,
];

const COLLECTION_APPS_ENDPOINTS = [
	// 首页合集应用列表
	/api\/resources\/v1\/topics\/pubs/,
];

const COLLECTION_DETAIL_APPS_ENDPOINTS = [
	// 合集详情应用列表
	/api\/resources\/v1\/topics\/[\w\d]+\/pub-apps/,
];

const SEARCH_APPS_ENDPOINTS = [
	// 搜索列表
	/api\/community\/v1\/search/,
];

export const APPS_ENDPOINTS = {
	COMMON: COMMON_APPS_ENDPOINTS,
	HOME_FAVORITE: HOME_FAVORITE_APPS_ENDPOINTS,
	HOME: HOME_APPS_ENDPOINTS,
	COLLECTION: COLLECTION_APPS_ENDPOINTS,
	COLLECTION_DETAIL: COLLECTION_DETAIL_APPS_ENDPOINTS,
	SEARCH: SEARCH_APPS_ENDPOINTS,
};
